export default __webpack_public_path__ + "static/lamudi-47ca1564ef224dd4ad80ca79600adb3d.png";